import React from 'react';
import {
    withStyles,
    Typography,
    Grid,
    Divider,
    InputBase,
    InputAdornment,
} from '@material-ui/core';


class MEditText extends React.Component {

    constructor(props) {
        super(props);
    }


    render() {
        const { classes, } = this.props;
        return (
            <Grid container direction='column' alignItems='center' className={classes.root}>
                <InputBase
                    fullWidth
                    type={this.props.type}
                    className={classes.input}
                    placeholder={this.props.placeholder}
                    value={this.props.value}
                    onChange={event => this.props.onChange(event)}
                    inputProps={{ maxLength: this.props.maxLength }}
                    startAdornment={
                        <InputAdornment position="start">
                            <Typography className={classes.inputTitle} >{this.props.startLabel}</Typography>
                        </InputAdornment>
                    }
                    endAdornment={this.props.endAdornment}
                />
                <Divider className={classes.diviver} />
            </Grid>
        );
    }
}

export default withStyles((theme) => ({
    root: {
        height: 50,
        alignItems: 'center',
    },
    input: {
        border: 0,
        outline: 'none',
        backgroundColor: 'transparent',
        color: '#0D0D0D',
    },
    inputTitle: {
        padding: theme.spacing(0, 1, 0, 0),
        fontSize: 16,
        minWidth: 60,
    },
    diviver: {
        color: '#E2E2E2',
        height: 1,
        width: '100%',
        marginTop: 8,
    }
}))(MEditText);